module.exports = function ($ocLazyLoadProvider) {
    $ocLazyLoadProvider.config({
        modules: 'wowModules' in window ? window.wowModules : []
    });
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/modules.js
 **/